var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.058 9.382c0 3.965-1.611 7.34-3.058 7.34-1.447 0-3.058-3.375-3.058-7.34s1.611-7.38 3.058-7.38c1.447 0 3.058 3.415 3.058 7.38zm-7.34 0c0 2.713.7 5.29 1.786 6.895-2.823-1.023-4.844-3.72-4.844-6.895a7.389 7.389 0 014.844-6.935C8.418 4.052 7.719 6.669 7.719 9.382zm6.778 6.895c2.823-1.023 4.844-3.72 4.844-6.895a7.389 7.389 0 00-4.844-6.935c1.087 1.605 1.785 4.222 1.785 6.935 0 2.713-.698 5.29-1.785 6.895zm-.686 2.541l1.042-1.625a7.348 7.348 0 002.143-1.4l-1.94 3.026h.09a.524.524 0 110 1.048h-.524v.559c0 .867-.706 1.572-1.573 1.572h-2.096a1.574 1.574 0 01-1.573-1.572v-.56h-.524a.524.524 0 110-1.047h.09l-1.94-3.026a7.348 7.348 0 002.143 1.4l1.042 1.625h1.286v-1.075l.06.005c.153.01.307.022.464.022.157 0 .31-.011.464-.022l.06-.005v1.076h1.286z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFill);
export default __webpack_public_path__ + "cc9cf1ea8ce0a23f12801d38152c8320.svg";
export { ForwardRef as ReactComponent };